import { render } from "./GraphsComponent.vue?vue&type=template&id=c2e79d46&scoped=true"
import script from "./GraphsComponent.vue?vue&type=script&lang=js"
export * from "./GraphsComponent.vue?vue&type=script&lang=js"

import "./GraphsComponent.vue?vue&type=style&index=0&id=c2e79d46&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c2e79d46"]])

export default __exports__